import React from 'react';
import styled from 'styled-components/macro';
import { Heading3 } from '../../../components/typography';
import { deliveryTypes } from '../../../features/commerce';
import {
  FreeDeliveryChoice,
  NoDeliveryChoice,
  DeliveryAndPickupChoice,
} from './LeveringComponenter';
import { Row, Col } from '../../../components/grid';
import { deliveryChooser } from '../../../containers/commerce/withDeliveryInfo';

export const ConnectedDeliveryAndPickup = deliveryChooser(deliveryTypes.deliveryAndPickup)(DeliveryAndPickupChoice);

export const ConnectedFree = deliveryChooser(deliveryTypes.delivery)(FreeDeliveryChoice);

export const ConnectedNo = deliveryChooser(deliveryTypes.no)(NoDeliveryChoice);

const BestilOrder = [ConnectedNo, ConnectedDeliveryAndPickup, ConnectedFree];

export const LeveringsTypeSubForm = ({ orderedComponents }) => (
  <React.Fragment>
    <Row>
      {orderedComponents.map(
        (Component, index) => (
          <Col xs={12} padding="15px 0 0 15px" key={index}>
            <Component />
          </Col>
        ),
      )}
    </Row>
  </React.Fragment>
);
const LeveringsTypeFormWrap = styled.div`
  padding-right: 15px;
`;
const leveringsTypeForm = order => () => (
  <LeveringsTypeFormWrap>
    <Heading3 marginBottom="0px">Leveringsmetode:</Heading3>
    <LeveringsTypeSubForm orderedComponents={order} />
  </LeveringsTypeFormWrap>
);

export const Levering = leveringsTypeForm(BestilOrder);
